import ConnectedSnackbarContainer from './containers/ConnectedSnackbarContainer';
import reducer from './reducer';
import reducerRegistry from '../../utils/reducerRegistry';
import {NAME} from './constants';

reducerRegistry.register(NAME, reducer);

export {ConnectedSnackbarContainer as default};